// extracted by mini-css-extract-plugin
module.exports = {"title":"PrivacyDialog_title__72uSh"};